/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loader[_ngcontent-%COMP%]{margin-top:20%}#reload-page[_ngcontent-%COMP%]{cursor:pointer;position:fixed;bottom:0;right:0}"];
export { styles as styles };
